{
    "Profile_Summary_Action.package_policy": "FR: This is a package policy.",
    "Profile_Summary_Action.update_underlier": "FR: To make changes, update the underlier policies in the package directly.",
    "Profile_Summary_Action.auto": "FR: Auto",
    "Profile_Summary_Action.home": "FR: Home",
    "Profile_Summary_Action.summary": "FR: Summary",
    "Profile_Summary_Action.part_of_package": "FR: This policy is part of a package.",
    "Profile_Summary_Action.renew_master": "FR: To renew this policy, trigger the renewal on the master policy.",
    "Profile_Summary_Action.home_and_auto": "FR: Home & Auto",

    "Profile_Summary_Action.policyStarts": "FR: Policy starts {date}",
    "Profile_Summary_Action.policyEnds": "FR: Policy ends {date}",
    "Profile_Summary_Action.quoteExpires": "FR: Quote expires {date}",
    "Profile_Summary_Action.policyNumber": "FR: Policy Number: {number}",
    "Profile_Summary_Action.binderNumber": "FR: Binder Number: {number}",
    "Profile_Summary_Action.selectedInsurer": "FR: Selected Insurer: {insurer}",
    "Profile_Summary_Action.pleaseContact": "FR: Please {contact} for more information",
    "Profile_Summary_Action.contact": "FR: contact us",

    "Profile_Summary_Action.summary_header": "FR: Summary",
    "Profile_Summary_Action.quote_reference": "FR: Quote Reference",
    "Profile_Summary_Action.premium": "FR: Premium",
    "Profile_Summary_Action.surcharges_total": "FR: Surcharges",
    "Profile_Summary_Action.discount_total": "FR: Discounts",
    "Profile_Summary_Action.fees": "FR: Fees",
    "Profile_Summary_Action.subtotal": "FR: SubTotal",
    "Profile_Summary_Action.taxes": "FR: Taxes",
    "Profile_Summary_Action.total": "FR: Total",

    "Profile_Summary_Action.discounts": "FR: Discounts",
    "Profile_Summary_Action.surcharges": "FR: Surcharges",

    "Profile_Summary_Action.incomplete": "FR: Incomplete",
    "Profile_Summary_Action.submitted": "FR: Submitted",
    "Profile_Summary_Action.accepted": "FR: Accepted",
    "Profile_Summary_Action.rejected": "FR: Rejected",
    "Profile_Summary_Action.declined": "FR: Declined",
    "Profile_Summary_Action.referred": "FR: Referred",
    "Profile_Summary_Action.underwritingRequired": "FR: Underwriting Required",
    "Profile_Summary_Action.cancelled": "FR: Policy Cancelled",
    "Profile_Summary_Action.deleted": "FR: Deleted",
    "Profile_Summary_Action.quoted": "FR: Quoted",
    "Profile_Summary_Action.quoteIssued": "FR: Quote Issued",
    "Profile_Summary_Action.quoteAccepted": "FR: Quote Accepted",
    "Profile_Summary_Action.lost": "FR: Lost",
    "Profile_Summary_Action.abandoned": "FR: Abandoned",
    "Profile_Summary_Action.bindRequested": "FR: Bind Requested",
    "Profile_Summary_Action.bound": "FR: Bound",
    "Profile_Summary_Action.issued": "FR: Issued",
    "Profile_Summary_Action.quoting": "FR: Quote In Progress",

    "Profile_Summary_Action.brokerage": "FR: Brokerage: {text}",
    "Profile_Summary_Action.assignedTo": "FR: Assigned To: {text}"
}
